import { ChipField as RAChipField } from 'react-admin';

const ChipField = RAChipField;

ChipField.defaultProps = {
  size: 'small',
};

export default ChipField;
